/* istanbul ignore file */
export enum EventTemplateCategoryType {
  /// <summary>
  /// A dynamic event template category, containing village favourites
  /// </summary>
  villageFavourite,
  /// <summary>
  /// A dynamic event template category, containing recently added templates
  /// </summary>
  recentlyAdded,
  /// <summary>
  /// A pre-defined event template category
  /// </summary>
  normal
}
